import { LAST_JACKPOT_GAMES_QUERY } from '@/api/query'
import { GenericRow, Participants, TableWrapper, UserBet } from '@/components/molecules/StyledTable/StyledTable'
import { Flex, Text, Tr } from '@chakra-ui/react'
import { useTranslation } from 'next-i18next/pages'
import { useQuery } from '@apollo/client'
import CrownIcon from '@/public/assets/icons/crown.svg'
import { SHU_DENOM, USDC_NEW_DENOM } from '@/constants/constants'
import { groupBy } from '@/helpers/groupBy'
import { BigNumberInWei } from '@injectivelabs/utils'
import { Game } from 'types/types'

export const LastGamesTable = () => {
  const { t } = useTranslation()

  const { data } = useQuery(LAST_JACKPOT_GAMES_QUERY)

  const filteredGames = data?.jackpotGames?.nodes.filter((node) => !!node)

  const games = filteredGames?.map((game) => {
    const bets = game!.jackpotBetsByGameId.nodes.map((bet) => ({
      address: bet!.address,
      amount: bet!.amount,
    }))

    const players = [...new Set(bets.map((bet) => bet.address))]

    const groupedBets = Object.entries(groupBy(bets, (bet) => bet.address!)).map(([address, bets]) => ({
      address,
      amount: bets.reduce((prev, curr) => new BigNumberInWei(curr.amount).plus(prev).toString(), '0'),
    }))

    const userBet = groupedBets.find((bet) => bet.address === game.playerWinner)!
    const multiplier = new BigNumberInWei(game?.winAmount).dividedBy(userBet.amount)

    return {
      bet: {
        amount: userBet.amount,
        denom: game.id <= 7655 ? USDC_NEW_DENOM : SHU_DENOM,
      },
      betId: '0',
      game: Game.JACKPOT,
      gameId: game?.id,
      multiplier: {
        isWon: true,
        number: multiplier.toFixed(2),
      },
      reward: {
        amount: game?.winAmount,
        denom: game.id <= 7655 ? USDC_NEW_DENOM : SHU_DENOM,
      },
      widget: <Participants winner={game?.playerWinner!} opponents={players} />,
    } as UserBet
  })

  if (!games?.length) {
    return null
  }

  return (
    <>
      <Flex gap={2} alignItems={'center'} mb={4}>
        <CrownIcon />
        <Text fontWeight={700}>{t('common.last-wins')}</Text>
      </Flex>
      <TableWrapper>
        {games.map((game, index) => {
          const isLastRow = index === games.length - 1
          return (
            <Tr key={game.gameId}>
              <GenericRow isLastRow={isLastRow} {...game} />
            </Tr>
          )
        })}
      </TableWrapper>
    </>
  )
}
